import React from 'react';
import { images } from '../data/atlasContent';
const paragraphs = ['Du schaust auf deine Pflanze. Etwas stimmt nicht. Die Blätter sind gelb. Oder braun. Oder verzerrt.', 'Du googelst. Du bekommst 47 verschiedene Antworten. Eine sagt: „Das ist Stickstoff-Mangel." Eine andere: „Das ist pH-Blockade." Eine dritte: „Das ist ein Virus."', 'Du machst eine Diagnose. Zu 50 % richtig. Du fügst Stickstoff hinzu, weil das am häufigsten ist.', 'Nach 3 Tagen: Die Pflanze sieht noch schlimmer aus. Du machst das Problem nur größer.', 'Nach 1 Woche: Die Ernte ist zerstört. Du verlierst €200–500. Und die schlimmste Sache? Du weißt immer noch nicht, was schiefgegangen ist.'];
export function Agitation() {
  return <section className="border-b border-line bg-surface py-20 lg:py-28" style={{
    paddingTop: "0px",
    paddingBottom: "0px"
  }} data-id="element-1" data-mp="3bk7t3s9uqv33">
      <div className="mx-auto max-w-7xl px-6 space-y-[14px]" data-id="element-2" data-mp="2ntc2uzl1o7xy">
        <h2 className="max-w-3xl font-serif text-3xl font-semibold leading-tight tracking-tight text-forest sm:text-4xl" data-id="element-3" data-mp="2ju3ds80y8y8q">
          Das stille Sterben: Warum 94 % der Urban Farmer scheitern (und du merkst es nicht mal)
        </h2>

        <div className="mt-12 grid grid-cols-1 gap-12 lg:grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)] lg:gap-16" data-id="element-4" data-mp="3cmsslp2ho4ys">
          <div className="rounded-2xl border border-line bg-surface p-6 text-lg leading-relaxed text-prose shadow-md shadow-forest/10 space-y-[6px] sm:p-8" data-id="element-5" data-mp="3hh6rw2k9uw8q">
            {paragraphs.map((text, i) => <p key={i} className={i === paragraphs.length - 1 ? 'font-medium text-forest' : undefined} data-id="element-6" data-mp="2orzl6ganz0ce" data-mpi={i}>
                {text}
              </p>)}

            
          </div>

          <figure className="self-start" data-id="element-7" data-mp="2ynknkfjna2mo">
            <img src={images.leafMacro} alt="Makroaufnahme eines Salatblatts mit Chlorose zwischen den Blattadern" className="w-full rounded-xl border border-line object-cover shadow-lg shadow-forest/10" style={{
            height: "257px"
          }} data-id="element-8" data-mp="2yqytfxriotyv" />
            <figcaption className="mt-3 font-mono text-xs leading-relaxed text-prose" data-id="element-9" data-mp="iwf1omvycsvu">
              Interveinale Chlorose. Drei mögliche Ursachen, eine richtige Antwort — ohne Referenzbild nicht
              unterscheidbar.
            </figcaption>
          </figure>
        </div>
      </div>
    </section>;
}